import type { AttributeValue, Tracer } from '@opentelemetry/api'
import {
  ATTRIBUTE_NAME_SESSION_ID,
  SPAN_NAME_OPERATION,
} from '../../telemetry/constants'
import { FriskSpan } from './frisk-span'

const FIELDS = {
  sessionId: ATTRIBUTE_NAME_SESSION_ID,
} as const

/** Typed span for a single operation (e.g. a nested LangChain run). */
export class OperationSpan extends FriskSpan {
  constructor(args: { tracer: Tracer; parent?: FriskSpan | null }) {
    super({ ...args, spanName: SPAN_NAME_OPERATION, attributeFields: FIELDS })
  }

  setAttributes(values: { sessionId?: string }): void {
    this.setAttributesByField(
      values as Record<string, AttributeValue | undefined>,
    )
  }
}
